module.exports = __webpack_public_path__ + "assets/icons/theft.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/theft.svg
// module id = nmcK
// module chunks = 1